import React from 'react'
import styled from 'styled-components'
import { FormattedMessage, useIntl } from 'react-intl'
import { Card } from 'antd'
import { Clock, HelpCircle, Percent, RefreshCw, Target, Award } from 'react-feather'

import { FlexColumn, FlexRow } from '../../FlexboxReusables/FlexItems'
import { ExamInfo } from '../types'
import ExamInstructionsBlock from './ExamInstructionsBlock'

type ExamInstructionsProps = {
  examInfo: ExamInfo
}

const ExamInstructions = (props: ExamInstructionsProps) => {
  const { examInfo } = props
  const intl = useIntl()

  return (
    <>
      <FlexRow width='100%'>
        <FlexColumn>
          <Card title={<FormattedMessage id='exam.instructions.title' />} bordered={true}>
            <ul>
              <ListItem>
                <FormattedMessage id='exam.instructions.1' values={{
                  buttonName: intl.formatMessage({ id: 'generic.start' })
                }} />
              </ListItem>
              <ListItem>
                <FormattedMessage id='exam.instructions.2' />
              </ListItem>
              <ListItem>
                <FormattedMessage id='exam.instructions.3' />
              </ListItem>
              <ListItem>
                <FormattedMessage id='exam.instructions.4' />
              </ListItem>
              <ListItem>
                <FormattedMessage id='exam.instructions.5' values={{
                  maxTries: examInfo.maxTries - 1 // -1 because the translation says how often you can RETAKE the exam
                }} />
              </ListItem>
            </ul>
          </Card>
        </FlexColumn>

        <FlexColumn width='50%'>
          <ExamInstructionsBlock
            Icon={Percent}
            heading={intl.formatMessage({ id: 'exam.minPercentageToPass' })}
            text={`${examInfo.minPercentageToPass}%`}
          />
          <ExamInstructionsBlock
            Icon={Target}
            heading={intl.formatMessage({ id: 'exam.totalPointsToAchieve' })}
            text={examInfo.totalPoints}
          />
          <ExamInstructionsBlock
            Icon={Clock}
            heading={intl.formatMessage({ id: 'exam.examDurationLong' })}
            text={examInfo.examDurationInMinutes}
          />
          <ExamInstructionsBlock
            Icon={HelpCircle}
            heading={intl.formatMessage({ id: 'exam.numberOfQuestions' })}
            text={examInfo.numberOfQuestions}
          />
          <ExamInstructionsBlock
            Icon={RefreshCw}
            heading={intl.formatMessage({ id: 'exam.maxTries' })}
            text={examInfo.maxTries}
          />
          <ExamInstructionsBlock
            Icon={Award}
            heading={'Zertifikatsgültigkeit'}
            text={`${examInfo.examValidityMonths} Monate` || 'unbegrenzt'} // TODO: i18n
          />
        </FlexColumn>
      </FlexRow>
    </>
  )
}

export default ExamInstructions

const ListItem = styled.li`
  margin: 0.5em 0;
  font-size: 1rem;
`